import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FamilyAfterPurchaseModalProps } from './FamilyAfterPurchaseModal';

export const openFamilyAfterPurchaseModal = ({ onClose, ...data }: FamilyAfterPurchaseModalProps) =>
    openPopupHelper({ popupName: popupNames.FAMILY_AFTER_PURCHASE_MODAL, data, onClose });

export const closeFamilyAfterPurchaseModal = () => closePopupHelper(popupNames.FAMILY_AFTER_PURCHASE_MODAL);
